<template>
  <div>
    <h4 class="mb-1">Статистика привязки</h4>
    <b-alert v-if="errorText" show variant="danger">{{ errorText }}</b-alert>
    <b-card v-if="stats">
      <p>Доля привязанных результатов: <b>{{ percent }}%</b> ({{ stats.linkedResults }} / {{ stats.totalResults }})</p>
      <p>Серых профилей: <b>{{ stats.greyProfiles }}</b></p>
      <p>Неоднозначных совпадений: <b>{{ stats.ambiguousMatches }}</b></p>
      <h5>Серые профили по возрасту</h5>
      <ul>
        <li v-for="(value, key) in stats.greyAgeDistribution" :key="key">{{ key }}: {{ value }}</li>
      </ul>
    </b-card>
  </div>
</template>

<script>
import { BAlert, BCard } from 'bootstrap-vue'
import identityApi from '@/services/identity-api.service'

export default {
  name: 'IdentityStatsPage',
  components: { BAlert, BCard },
  data() {
    return { stats: null, errorText: '' }
  },
  computed: {
    percent() {
      if (!this.stats) return 0
      return Math.round((this.stats.linkedShare || 0) * 100)
    },
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      try {
        const { data } = await identityApi.getStats()
        this.stats = data
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Не удалось загрузить статистику'
      }
    },
  },
}
</script>
